import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {TopicMapper} from '../mappers/topic.mapper';

@Injectable({
    providedIn: 'root'
})
export class TopicUseCase {
    constructor(
        private mapper: TopicMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run(topicId) {
        // return this.data.getTopicDetail(topicId);
        return this.data.getTopicDetail(topicId).pipe(this.mapper.map);
    }
}
